/**
 * Local storage utils
 */

const PREFIX = 'PisanoCacher::';
const getPrefixedKey = (key) => `${PREFIX}${key}`;

let hasStorage = true;
let store = {};

try {
  const ls = window.localStorage;
  ls.setItem('testingLocalStorage', 'test');
  ls.removeItem('testingLocalStorage');
  store.setItem = (key, val) => ls.setItem(getPrefixedKey(key), JSON.stringify(val));
  store.getItem = (key) => JSON.parse(ls.getItem(getPrefixedKey(key)));
  store.removeItem = (key) => ls.removeItem(getPrefixedKey(key));
} catch (e) {
  console.error('Error accessing localStorage:', e);
  hasStorage = false;
}

if (!hasStorage) {
  store = (() => {
    let length = 0;
    let store = {};
    return {
      setItem: (key, value) => {
        const prefixedKey = getPrefixedKey(key);
        if (!store[prefixedKey]) length += 1;
        store[prefixedKey] = JSON.stringify(value);
      },
      getItem: (key) => {
        const raw = store[getPrefixedKey(key)];
        return raw !== undefined ? JSON.parse(raw) : null;
      },
      removeItem: (key) => {
        const prefixedKey = getPrefixedKey(key);
        if (store[prefixedKey]) {
          delete store[prefixedKey];
          length -= 1;
        }
      },
      clear: () => {
        store = {};
        length = 0;
      },
      key: (i) => Object.keys(store)[i],
      length: () => length,
    };
  })();
}

export default store;
